import { lookupWorkOsOrganizations } from '@dealstack/frontend/shared/dataExchange/services/organization.api';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { useQuery } from '@tanstack/react-query';

export const useWorkOsOrganizationLookup = (domain: string, enabled: boolean) => {
	return useQuery({
		queryKey: [API_PATHS.ORGANIZATION_WORKOS_LOOKUP_GET, domain],
		queryFn: async () => {
			const result = await lookupWorkOsOrganizations(domain);
			return result.payload ?? null;
		},
		enabled: enabled && domain.length > 0,
	});
};
